import { render, staticRenderFns } from "./PrimitiveValues.vue?vue&type=template&id=69229717"
import script from "./PrimitiveValues.vue?vue&type=script&lang=js"
export * from "./PrimitiveValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports